/* eslint-disable angular/controller-as */
angular.
module("digiexam").
controller("DxEditCourseController", function EditCourseController(
	$scope,
	course,
	dxDialog
) {
	"use strict";
	$scope.originalTitle = $scope.course.title;
	$scope.showConfirmArchiveDialog = false;
	$scope.isValid = false;

	$scope.$watch("course", function onChange() {
		var valid = true;

		if ($scope.course.title === $scope.originalTitle) {
			valid = false;
		}

		if (!$scope.course.title || $scope.course.title.length === 0) {
			valid = false;
		}

		$scope.isValid = valid;
	}, true);

	$scope.save = function save() {
		var promise = course.update($scope.course);
		promise.then(function close() {
			dxDialog.closeMostRecent();
		});
	};

	$scope.archive = function archive() {
		$scope.course.isArchived = true;
		$scope.save();
	};

	$scope.cancelEditGroup = function cancelEditGroup() {
		$scope.course.title = $scope.originalTitle;
		dxDialog.closeMostRecent();
	};
});
